
import { Component, Mixins, Prop } from 'vue-property-decorator'
import StateMixin from '@/mixins/state'

@Component({})
export default class FileNameDialog extends Mixins(StateMixin) {
  @Prop({ type: Boolean, required: true })
  public value!: boolean

  @Prop({ type: String, required: true })
  public title!: string

  @Prop({ type: String, required: true })
  public label!: string

  @Prop({ type: Array, required: false })
  public rules!: []

  @Prop({ type: String, required: true })
  public name!: string

  newName = ''
  valid = false

  mounted () {
    this.newName = this.name
  }

  handleSave () {
    if (this.valid) {
      this.$emit('save', this.newName)
      this.$emit('input', false)
    }
  }
}
